import React, { useEffect, useState } from 'react';
import { Radio, Select, Input, Space } from '../';

const MODE = { EXISTING: 'existing', CREATE: 'create' };

export const ResourceGroupSelector = ({
    value = '',
    onChange,
    resourceGroups = [],
    loading = false,
    disabled = false,
}) => {
    const [mode, setMode] = useState(MODE.EXISTING);

    useEffect(() => {
        const findResourceGroup = resourceGroups?.find((group) => group?.name?.toLowerCase() === value.toLowerCase());
        if (value) {
            setMode(findResourceGroup ? MODE.EXISTING : MODE.CREATE);
        }
    }, [value, resourceGroups]);

    const handleModeChange = (event) => {
        setMode(event.target.value);
        onChange?.('');
    };

    const options = resourceGroups
        .map((group) => ({ value: group.name, label: group.name }))
        .sort((a, b) => a.label.localeCompare(b.label));

    return (
        <Space orientation="vertical" size="small" style={{ width: '100%' }}>
            <Radio.Group value={mode} onChange={handleModeChange} disabled={disabled}>
                <Radio value={MODE.CREATE}>Create new</Radio>
                <Radio value={MODE.EXISTING}>Use existing</Radio>
            </Radio.Group>

            {mode === MODE.EXISTING ? (
                <Select
                    placeholder="Select a resource group"
                    value={value || undefined}
                    onChange={onChange}
                    options={options}
                    loading={loading}
                    disabled={disabled}
                    showSearch={{optionFilterProp: "label"}}
                />
            ) : (
                <Input
                    placeholder="Enter a new resource group name"
                    value={value}
                    onChange={(event) => onChange?.(event.target.value)}
                    disabled={disabled}
                />
            )}
        </Space>
    );
};

export default ResourceGroupSelector;
